"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.profileLanguageDetector = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs3/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/asyncToGenerator"));

var _auth = require("../auth");

var profileLanguageDetector = {
  name: 'profileLanguage',
  lookup: function () {
    var _lookup = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      var auth, user, claims, language;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              auth = (0, _auth.getCustomAuthProvider)();
              user = auth.user();
              claims = user && user.rawClaims;
              language = claims && typeof claims.xms_pl === 'string' ? claims.xms_pl : undefined;
              return _context.abrupt("return", language);

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function lookup() {
      return _lookup.apply(this, arguments);
    }

    return lookup;
  }()
};
exports.profileLanguageDetector = profileLanguageDetector;